import React from 'react';
import {
    Typography,
    Box,
} from '@mui/material';
import { useDroppable } from '@dnd-kit/core';
import DraggableItem from './DraggableItem';
import AssignmentSkeletonList from 'ui-component/AssignmentSkeletonList/AssignmentSkeletonList';

const   DroppableList = ({ id, items, title, isLoading, canEdit }) => {
    const { setNodeRef } = useDroppable({ id, disabled: !canEdit });
    return (
        <Box
            ref={setNodeRef}
            sx={{
                border: '1px solid #ddd',
                borderRadius: 2,
                p: 2,
                minHeight: 340,
                backgroundColor: '#fafafa',
                overflowY: 'auto',
                boxShadow: 'inset 0 0 4px rgba(0,0,0,0.05)',
                transition: 'background-color 0.2s',
                maxHeight: 300
            }}
        >
            <Typography
                variant="subtitle1"
                gutterBottom
                fontWeight={700}
                sx={{
                    mb: 1,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5
                }}
            >
                {title}
            </Typography>
            {
                isLoading ? (
                    <AssignmentSkeletonList count={4} />
                ) : items.length === 0 ? (
                    <Typography variant="body2" color="text.secondary">
                        No items
                    </Typography>
                ) : (
                    items.map((item) => <DraggableItem key={item.id} id={item.id} name={item.name} indicatorColor={id === "assigned" ? "#3CB371" : "#1976d2"} isHidden={item.parentId == "1"} canEdit={canEdit} />)
                )
            }

        </Box>
    );
};
export default DroppableList;